@if (isNavigating) {
  <div class="clb-app-splash">
    <img class="clb-app-splash__logo" src="assets/images/colobbo_logo_mini.svg" alt="Colobbo">
    <div class="clb-app-splash__bar-track">
      <div class="clb-app-splash__bar-fill"></div>
    </div>
  </div>
}
<router-outlet />
<app-impersonation-banner />
